import { chipClasses as a } from "@mui/material";
const p = {
  styleOverrides: {
    root: ({ theme: i }) => ({
      ...i.typography.overline,
      borderRadius: `${i.spacing(2)} !important`,
      width: "max-content",
      height: "32px",
      padding: i.spacing(0.5)
    }),
    sizeSmall: ({ theme: i }) => ({
      ...i.typography.caption,
      padding: `${i.spacing(0.125)} ${i.spacing(0.25)}`,
      height: "18px",
      [`.${a.icon}`]: {
        fontSize: i.tokens.fontSize[0]
      },
      display: "flex"
    }),
    label: ({ theme: i }) => ({
      padding: `${i.spacing(0.4)} ${i.spacing(0.75)}`
    }),
    icon: ({ theme: i }) => ({
      margin: 0,
      marginLeft: i.spacing(0.5),
      opacity: 0.6
    }),
    deleteIcon: {
      margin: 0
    },
    avatar: {
      margin: 0
    }
  }
};
export {
  p as chip
};
//# sourceMappingURL=chip2.mjs.map
